import BackofficeInterceptor from '../BackofficeInterceptor'

const api = new BackofficeInterceptor();

export default {
  getLocalExecucaoById(localId) {
    return api.get(`/local-execucao/${localId}`)
  },

  getLocaisExecucao() {
    return api.get('/local-execucao')
  },
}
